<template>
    <div class="table-wrap">
        <p class="table-top-text">
            <span class="font-main">*</span> 표시는 필수 입력 항목입니다.{{$store.getters.getHost}}
        </p>
        <div class="table table-input">
            <table>
                <colgroup>
                    <col style="width:25%;">
                    <col style="width:25%;">
                    <col style="width:25%;">
                    <col style="width:25%;">
                </colgroup>
                <tbody>
                    <tr>
                        <th>이름</th>
                        <td colspan="3" class="left">{{$store.state.myInfoStore.name}}</td>
                    </tr>
                    <tr>
                        <th>휴대전화</th>
                        <td class="left">{{$store.state.myInfoStore.hpNo}}</td>
                        <th>이메일</th>
                        <td class="left">{{$store.state.myInfoStore.email}}</td>
                    </tr>
                    <tr>
                        <th><span class="font-main">*</span> 제목</th>
                        <td colspan="3"><input type="text" placeholder="제목을 입력하세요." v-model="params.title"></td>
                    </tr>
                    <tr>
                        <th rowspan="2">고마운 선생님</th>
                        <td colspan="3" class="left">
                            <div class="table-input__box">
                                <h4 class="input-title">의료진</h4>
                                <div class="table-input__medical">
                                    <input type="text" placeholder="의료진을 검색해주세요." @keyup.enter="$refs.searchDoc.popupBtn" @click="$refs.searchDoc.popupBtn" readonly>
                                    <input type="text" placeholder="검색창에서 입력하신 의료진이 표시됩니다." v-model="viewDrName" readonly>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="3" class="left">
                            <div class="table-input__box">
                                <h4 class="input-title">교직원</h4>
                                <input type="text" placeholder="소속과 이름을 입력해주세요." v-model="params.item1">
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th><span class="font-main">*</span> 내용</th>
                        <td colspan="3">
                            <textarea name="" id="" placeholder="내용을 입력하세요." v-model="params.content"></textarea>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="botton-wrap type01">
        <a href="javascript:;" class="sub-button c-main" @click="cancelArticle">취소</a>
        <a href="javascript:;" class="main-button c-main" @click="insertArticle">등록</a>
    </div>
    <kr_popup_searchDoctor ref="searchDoc" @setParams="setParams"></kr_popup_searchDoctor>
</template>

<script>
export default {
    props: {
        boardInfo: ''
    },
    data() {
        return {
            params: { content: '', },
            byteCount: 0, // 현재 바이트 수
            doctorList: '',
        }
    },
    watch: {
        // 'params.content'(newVal) {
        //     this.checkByteLength(); // 바이트 수 업데이트
        // }
    },
    methods: {
        cancelArticle() {
            if (confirm('글 작성을 취소하시겠습니까?')) {
                this.$router.push({ path: `${this.$route.path.replace('/register', '/list')}` })
            }
        },
        insertArticle() {
            if (!this.params.title || !this.params.content) {
                alert('필수 입력 항목을 모두 입력해 주세요.');
                return;
            }

            if (confirm('등록하시겠습니까?')) {
                for(let i of Object.keys(this.params)){
                    if(i == 'refDoctorList') this.params['refDoctorList'] = JSON.stringify(this.params['refDoctorList']) 
                }
                var bid = 10

                this.params.item18 = 'R'
                this.params.hospIds = 'H0006,H0007,H0008'
                if(this.$store.getters.getHost == 'H0009') this.params.hospIds = 'H0009'

                this.axios({
                    method: "post",
                    url: this.api.article.insert + bid,
                    headers: { 'Content-type': 'multipart/form-data' },
                    data: this.params
                }).then(response => {
                    alert("글이 등록되었습니다");
                    // 이용안내
                    this.$router.push({ path: `${this.$route.path.replace('/register', '/list')}` })
                }).catch((err) => {
                    alert('오류가 발생했습니다. 다시 시도해주시길 바랍니다.')
                    location.reload(true);
                });
            }
        },
        checkByteLength() {
            const byteLength = new Blob([this.params.content]).size; // 바이트 수 계산
            this.byteCount = byteLength;

            if (byteLength > 1000) {
                alert('입력 횟수가 초과되었습니다.');
                this.trimContentToLimit(); // 1000 바이트를 넘으면 내용 잘라냄
            }
        },
        trimContentToLimit() {
            let content = this.params.content;
            let byteLength = 0;
            let trimmedContent = '';

            // 바이트 수가 1000을 넘지 않도록 글자를 하나씩 확인하며 잘라냄
            for (let i = 0; i < content.length; i++) {
                let char = content[i];
                byteLength += new Blob([char]).size;
                if (byteLength > 1000) break;
                trimmedContent += char;
            }

            this.params.content = trimmedContent; // 잘린 내용을 다시 적용
            this.byteCount = new Blob([this.params.content]).size; // 바이트 수 갱신
        },
        setParams(param){
            Object.assign(this.params, param)
        },
    },
    mounted() {
        // this.checkByteLength(); // 처음 로드될 때 바이트 수 체크
    },
    computed: {
        viewDrName: {
            get() {
                if (this.params.refDoctorList && Array.isArray(this.params.refDoctorList)) {
                    return this.params.refDoctorList.map(i => i.name).join(', ')
                }
                return ''
            }
        }
    }
}
</script>

<style scoped></style>
